<template>

<div v-if='isLoading' class="loader text-center">
    <img src='/resources/loader.svg' width="100px">
</div>

</template>

<script>
    export default {

        mounted() {
            var me = this;

            bus.$on('loader', ( state ) => {

                me.isLoading = state;

            })
        },

        created() {

        },

        data() {

            return {
                isLoading : false
            }

        },

        methods : {
           
        }

    }
</script>

<style lang='less'>
   .loader{
        position: fixed;
        z-index: 99999;
        background-color: rgba(255,255,255,0.4);
        width: 90%;
        height: 85%;

        img{
            max-width: 100%;
        }
   } 
</style>